var PostSearch = {
  translations: undefined,
  searchCategory: undefined,
  searchPartner: undefined,
  searchBrand: undefined,

  getTranslation: function(keyword, lang) {
      if (!Search.translations[keyword])
          return keyword;
      var translations = Search.translations[keyword];
      if (!translations[lang])
          return translations["et"];
      else
          return translations[lang];
  },

  init: function(
  //applicationId, applicationKey,
  centerId, partnerId, centerSlug, cartTranslation) {

      //var client = $.algolia.Client(applicationId, applicationKey);
      //var postsIndex = client.initIndex('posts');
      var categoryResults = $('#categoryExtra');
      var partnerResults = $('#partnerExtra');
      var partnerResultsSmall = $('#partnerExtraSmall');
      var brandResults = $('#brandExtra');
      var postTemplate = $('#postsearch-result').html();
      var latestQuery = "";

      function render(el, template, resultsContainer, callback) {
        var renderable = doT.template(template);
        el.centerSlug = centerSlug;
        resultsContainer.append(renderable(el));

        if (!!callback) callback(el);
      }

      function searchDone(content, searchResultContainer, template, callback) {
        if (content.query == latestQuery) {
          searchResultContainer.empty();
          content.hits.forEach(function(el) {
            render(el, template, searchResultContainer, callback)
          });
          if(content.hits.length === 0) {
            searchResultContainer.parent().parent().hide();
            console.log("searchresultcontainer id:", searchResultContainer.attr('id'));
            if (searchResultContainer.attr('id') === 'categoryExtra')
              $('#categoryArticlesReplacement').show();
          }
          var isInCartIndicator = '<div class="alert alert-card alert-success"><a href="/checkout/"><img src="/assets/svg/check-circle-green.svg" />'+cartTranslation+' ›</a></div>';
          searchResultContainer.find('.add-to-cart').on('click', function(e) {
            Cart.addItem($(this).data('variation-id'), 1);
            $(this).closest('.card').find('.card-image').html(isInCartIndicator);
            e.preventDefault();
          });
        }
      }

      this.searchCategory = (categoryId) => {
        var query = { source: "post", query: "", index: "posts", numericFilters: []};
        query.hitsPerPage = 5;
        query.numericFilters.push("breadCrumb=" + categoryId);

        var ajaxCall = new Promise((resolve, reject) => {

            $.ajax({
                type: 'POST',
                url: '/searchproxy2/',
                data: JSON.stringify(query),
                datatype: 'json',
                contentType: 'application/json',
                complete: function (results, textStatus, jqXHR) {

                    //console.log(results);
                    resolve(results);
                }
            });
        });

        return ajaxCall.then(function(response) {
            if (response) {
                searchDone(response, categoryResults, postTemplate);
                //return response;
            }
        });

        //postsIndex.search(query, function(err, content) {
          //searchDone(content, categoryResults, postTemplate)
        //});
      }
      this.searchPartner = () => {
        var query = { source: "post", query: "", index: "posts", numericFilters: []};
        query.hitsPerPage = 5;
        query.numericFilters.push("partnerId=" + partnerId);

        var ajaxCall = new Promise((resolve, reject) => {

            $.ajax({
                type: 'POST',
                url: '/searchproxy2/',
                data: JSON.stringify(query),
                datatype: 'json',
                contentType: 'application/json',
                complete: function (results, textStatus, jqXHR) {

                    //console.log(results);
                    resolve(results);
                }
            });
        });

        return ajaxCall.then(function(response) {
            if (response) {
                searchDone(response, partnerResults, postTemplate);
                //return response;
            }
        });

        //postsIndex.search(query, function(err, content) {
          //searchDone(content, partnerResults, postTemplate)
        //});
      }
      this.searchPartnerSmall = () => {
        var query = { source: "post", query: "", index: "posts", numericFilters: []};
        query.hitsPerPage = 3;
        query.numericFilters.push("partnerId=" + partnerId);

        var ajaxCall = new Promise((resolve, reject) => {

            $.ajax({
                type: 'POST',
                url: '/searchproxy2/',
                data: JSON.stringify(query),
                datatype: 'json',
                contentType: 'application/json',
                complete: function (results, textStatus, jqXHR) {

                    //console.log(results);
                    resolve(results);
                }
            });
        });

        return ajaxCall.then(function(response) {
            if (response) {
                searchDone(response, partnerResultsSmall, postTemplate);
                //return response;
            }
        });

        //postsIndex.search(query, function(err, content) {
          //searchDone(content, partnerResultsSmall, postTemplate)
        //});
      }
      this.searchBrand = (brand) => {
        var query = { source: "post", query: "", index: "posts", facetFilters: []};
        query.hitsPerPage = 5;
        query.facetFilters.push("brand=" + brand);

        //var query = {query: "", "facetFilters": [["brand:"+brand]]};
        //query.hitsPerPage = 5;

        var ajaxCall = new Promise((resolve, reject) => {

            $.ajax({
                type: 'POST',
                url: '/searchproxy2/',
                data: JSON.stringify(query),
                datatype: 'json',
                contentType: 'application/json',
                complete: function (results, textStatus, jqXHR) {

                    //console.log(results);
                    resolve(results);
                }
            });
        });

        return ajaxCall.then(function(response) {
            if (response) {
                searchDone(response, brandResults, postTemplate);
                //return response;
            }
        });

        //postsIndex.search(query, function(err, content) {
          //console.log("ERR:", err);
          //searchDone(content, brandResults, postTemplate)
        //});
      }
   }
  };
